import { Button, Box } from '@mui/material';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Page, PageTitleWithButton } from '../../../components';
import { UsersList } from './users-list';
import { Add } from '@mui/icons-material';
import { useContext } from 'react';
import { UserContext } from '../../../context';
import { useFlags } from '../../../hooks';
import { UserRoles } from '../../../models';

interface IUsersPage {}

export const UsersPage: FC<IUsersPage> = () => {
  const history = useHistory();
  const { user } = useContext(UserContext);
  const canCreateUser = user?.userRoles?.includes(UserRoles.BLCreateEntraUser);
  const featureFlags = useFlags();

  return (
    <Page title={'Unified User Management'}>
      <PageTitleWithButton
        pageTitleBackProps={{
          showDivider: false,
          backText: 'Back to Admin home',
          backUrl: '/admin',
          title: 'Unified User Management'
        }}
        button={
          canCreateUser &&
          featureFlags?.entraUserCreationOrigin && (
            <Box flexWrap="wrap" display="flex" alignItems="center">
              <Button
                id="create-new--user"
                onClick={async () => {
                  history.push('/admin/user-tools/unified-user-management/add-new-user');
                }}
                color="primary"
                variant="contained"
                startIcon={<Add />}
                fullWidth
              >
                Add User
              </Button>
            </Box>
          )
        }
      />
      <UsersList />
    </Page>
  );
};
